import constants from "../config/constants";
import { postRequest, formDataRequest } from "../libs/AxiosService.util";
import axios from "axios";


export async function serviceGetLeadsMaster(params) {
  return await postRequest("contacts/leads", params);
}

export async function serviceCreateLead(params) {
  return await postRequest("leads/create", params);
}

export async function serviceUpdateLead(params) {
  return await postRequest("leads/update", params);
}

export async function serviceUpdateLeadWithContact(params) {
  return await postRequest("leads/update/with-contact", params);
}

export async function serviceUpdateLeadAddress(params) {
  return await postRequest("leads/update/address", params);
}

export async function serviceUpdateLeadStatus(params) {
  return await postRequest("leads/update/status", params);
}

export async function serviceGetLeadsKanbanList(params) {
  return await postRequest("leads/kanban", params);
}

export async function serviceGetLeadsListByMe(params) {
  return await postRequest("leads/list-by-me", params);
}

/** Export leads list CSV using the same filters as list-by-me. */
export async function serviceExportLeadsListByMe(params = {}) {
  try {
    const response = await axios.post(
      `${constants.DEFAULT_APP_URL}leads/list-by-me/export`,
      { ...params },
      { responseType: "blob" }
    );
    const blob = new Blob([response.data], { type: "text/csv;charset=utf-8" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    const today = new Date().toISOString().slice(0, 10);
    link.href = url;
    link.setAttribute("download", `leads_list_export_${today}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => window.URL.revokeObjectURL(url), 1000);
    return { error: false };
  } catch (err) {
    return {
      error: true,
      message: err?.response?.data?.response_message || "Export failed",
    };
  }
}

export async function serviceGetLeadDetail(params) {
  return await postRequest("leads/detail", params);
}

export async function serviceGetLeadTimeline(params) {
  return await postRequest("leads/timeline", params);
}

export async function serviceGetLeadNotes(params) {
  return await postRequest("leads/notes/list", params);
}

export async function serviceAddLeadNote(params) {
  return await postRequest("leads/notes/create", params);
}

export async function serviceCreateLeadTask(params) {
  return await postRequest("leads/tasks/create", params);
}

export async function serviceUpdateLeadTask(params) {
  return await postRequest("leads/tasks/update", params);
}

export async function serviceGetLeadTasks(params) {
  return await postRequest("leads/tasks/list", params);
}

export async function serviceGetLeadTasksByAssignee(params) {
  return await postRequest("leads/tasks/list-by-assignee", params);
}

export async function serviceMarkLeadTaskComplete(params) {
  return await postRequest("leads/tasks/mark-complete", params);
}

export async function serviceCreateCallOutcome(params) {
  return await postRequest("leads/call-outcome", params);
}

export async function serviceCreateLeadQualifier(params) {
  return await postRequest("leads/qualifier/create", params);
}

export async function serviceGetLeadQualifier(params) {
  return await postRequest("leads/qualifier/by-lead", params);
}

export async function serviceGetLeadQualifierConfig(params) {
  return await postRequest("leads/qualifier/config", params);
}

export async function serviceGetPayoutQueries(params) {
  return await postRequest("doctor/payouts/queries", params);
}

export async function serviceCreatePayoutProcess(params) {
  return await postRequest("doctor/payouts/process", params);
}

export async function serviceGetPayoutDetail(params) {
  return await postRequest("doctor/payouts/detail", params);
}
export async function serviceGetCallLogsByLead(leadId) {
  return await postRequest("calllog/lead", { lead_id: leadId });
}

export async function serviceGetCallLogsByContact(contactId) {
  return await postRequest(`calllog/contact/${contactId}`, {});
}

export async function serviceGetCallAnalysis(params) {
  return await postRequest("call-recording-analysis/getByCustomerQueryIdOrAppointmentId", params);
}
export async function serviceAddPayout(params) {
  return await postRequest("doctor/payouts/add/adjustment", params);
}
export async function serviceGetDoctorBalance(params) {
  return await postRequest("doctor/payouts/balance", params);
}

export async function serviceCreateLeadQuotation(formData) {
  return await formDataRequest("leads/quotations/create", formData);
}

export async function serviceUpdateLeadQuotation(formData) {
  return await formDataRequest("leads/quotations/update", formData);
}

export async function serviceGetLeadQuotations(params) {
  return await postRequest("leads/quotations/by-lead", params);
}

export async function serviceGetLeadQuotationPdfUrl(params) {
  return await postRequest("leads/quotations/pdf-url", params);
}

export async function serviceDeleteLeadQuotation(params) {
  return await postRequest("leads/quotations/delete", params);
}

export async function serviceUploadLeadAttachment(formData) {
  return await formDataRequest("leads/attachments/upload", formData);
}

export async function serviceGetLeadAttachments(params) {
  return await postRequest("leads/attachments/by-lead", params);
}

export async function serviceGetLeadAttachmentUrl(params) {
  return await postRequest("leads/attachments/url", params);
}

export async function serviceDeleteLeadAttachment(params) {
  return await postRequest("leads/attachments/delete", params);
}

export async function serviceGetLeadsToolsList(params) {
  return await postRequest("leads/tools/list", params);
}

export async function serviceGetCallRecordToolsList(params) {
  return await postRequest("leads/tools/call-record/list", params);
}

export async function serviceMigrateLeads(params) {
  return await postRequest("leads/tools/migrate", params);
}

export async function serviceExportLeadsTools(params = {}) {
  try {
    const response = await axios.post(
      `${constants.DEFAULT_APP_URL}leads/tools/export`,
      { ...params },
      { responseType: "blob" }
    );
    const blob = new Blob([response.data], { type: "text/csv;charset=utf-8" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    const today = new Date().toISOString().slice(0, 10);
    link.href = url;
    link.setAttribute("download", `leads_export_${today}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => window.URL.revokeObjectURL(url), 1000);
    return { error: false };
  } catch (err) {
    return {
      error: true,
      message: err?.response?.data?.response_message || "Export failed",
    };
  }
}

export async function serviceExportCallRecordTools(params = {}) {
  try {
    const response = await axios.post(
      `${constants.DEFAULT_APP_URL}leads/tools/call-record/export`,
      { ...params },
      { responseType: "blob" }
    );
    const blob = new Blob([response.data], { type: "text/csv;charset=utf-8" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    const today = new Date().toISOString().slice(0, 10);
    link.href = url;
    link.setAttribute("download", `call_record_report_${today}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => window.URL.revokeObjectURL(url), 1000);
    return { error: false };
  } catch (err) {
    return {
      error: true,
      message: err?.response?.data?.response_message || "Export failed",
    };
  }
}